import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => {
    try { return window.localStorage.getItem('pd_token') || ''; } catch { return ''; }
  });
  useEffect(() => {
    if (token) window.localStorage.setItem('pd_token', token);
    else window.localStorage.removeItem('pd_token');
  }, [token]);
  const value = { token, setToken };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}


